export default {
  state: {
    permissions: [],
    isFullInfo: false,
    isMapFilter: false,
    showAnal: false,
    land: {},
    landEdit: {},
    typeZuList: null,
    categoryList: null,
    tluList: null,
    rightList: null,
    rightOwnerGovernanceSpList: null,
    ownerTypeList: null,
    encumbranceTypeList: null,
    documentTypeList: null,
    landUseList: null,
    landUseMerList: null,
    regionList: null,
    loadingLandDetail: false, // флаг загрузки подробной информации
    encumbranceDetail: [],
    rightIndex: null,
    encIndex: null,
    isAuthorized: false,
    editLoading: false,
    email: '',
    leftMenuDisplayMedia: true
  },
  mutations: {
    setValueIndex (state, keyValue) {
      // state[keyValue.key] = keyValue.value
      state[keyValue.key] = state[keyValue.key].map(item => {
        return 'false'
      })
      state[keyValue.key][keyValue.ind] = keyValue.value
    },
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    },
    SET_TYPE_ZU_LIST (state, typeZu) {
      state.typeZuList = typeZu
    },
    SET_CATEGORY_LIST (state, categoryList) {
      state.categoryList = categoryList
    },
    SET_TLU_LIST (state, tluList) {
      state.tluList = tluList
    },
    SET_RIGHT_LIST (state, rightList) {
      state.rightList = rightList
    },
    SET_RIGHT_OWNER_GOVERNANCE_SP_LIST (state, rightOwnerGovernanceSpList) {
      state.rightOwnerGovernanceSpList = rightOwnerGovernanceSpList
    },
    SET_OWNER_TYPE_LIST (state, ownerTypeList) {
      state.ownerTypeList = ownerTypeList
    },
    SET_ENCUMBRANCE_TYPE_LIST (state, encumbranceTypeList) {
      state.encumbranceTypeList = encumbranceTypeList
    },
    SET_DOCUMENT_TYPE_LIST (state, documentTypeList) {
      state.documentTypeList = documentTypeList
    },
    SET_LAND_USE_LIST (state, landUseList) {
      state.landUseList = landUseList
    },
    SET_LAND_USE_MER_LIST (state, landUseMerList) {
      state.landUseMerList = landUseMerList
    },
    SET_REGION_LIST (state, regionList) {
      state.regionList = regionList
    }
  },
  actions: {
    SET_VALUE_WITH_INDEX ({commit}, keyValue) {
      commit('setValueIndex', keyValue)
    },
    SET_VALUE ({commit}, keyValue) {
      commit('setValue', keyValue)
    },
    SET_TYPE_ZU_LIST ({commit}, typeZu) {
      commit('SET_TYPE_ZU_LIST', typeZu)
    },
    SET_CATEGORY_LIST ({commit}, typeZu) {
      commit('SET_CATEGORY_LIST', typeZu)
    },
    SET_TLU_LIST ({commit}, tluList) {
      commit('SET_TLU_LIST', tluList)
    },
    SET_RIGHT_LIST ({commit}, rightList) {
      commit('SET_RIGHT_LIST', rightList)
    },
    SET_RIGHT_OWNER_GOVERNANCE_SP_LIST ({commit}, rightOwnerGovernanceSpList) {
      commit('SET_RIGHT_OWNER_GOVERNANCE_SP_LIST', rightOwnerGovernanceSpList)
    },
    SET_OWNER_TYPE_LIST ({commit}, ownerTypeList) {
      commit('SET_OWNER_TYPE_LIST', ownerTypeList)
    },
    SET_ENCUMBRANCE_TYPE_LIST ({commit}, encumbranceTypeList) {
      commit('SET_ENCUMBRANCE_TYPE_LIST', encumbranceTypeList)
    },
    SET_DOCUMENT_TYPE_LIST ({commit}, documentTypeList) {
      commit('SET_DOCUMENT_TYPE_LIST', documentTypeList)
    },
    SET_LAND_USE_LIST ({commit}, landUseList) {
      commit('SET_LAND_USE_LIST', landUseList)
    },
    SET_LAND_USE_MER_LIST ({commit}, landUseMerList) {
      commit('SET_LAND_USE_MER_LIST', landUseMerList)
    },
    SET_REGION_LIST ({commit}, regionList) {
      commit('SET_REGION_LIST', regionList)
    }
  },
  getters: {
    value: (state, getters, rootState) => key => {
      for (let _state in rootState) {
        if (key in rootState[_state]) {
          return rootState[_state][key]
        }
      }
    },
    TYPE_ZU_LIST: state => {
      return state.typeZuList
    },
    CATEGORY_LIST: state => {
      return state.categoryList
    },
    TLU_LIST: state => {
      return state.tluList
    },
    RIGHT_LIST: state => {
      return state.rightList
    },
    RIGHT_OWNER_GOVERNANCE_SP_LIST: state => {
      return state.rightOwnerGovernanceSpList
    },
    OWNER_TYPE_LIST: state => {
      return state.ownerTypeList
    },
    ECUMBRANCE_TYPE_LIST: state => {
      return state.encumbranceTypeList
    },
    DOCUMENT_TYPE_LIST: state => {
      return state.documentTypeList
    },
    LAND_USE_LIST: state => {
      return state.landUseList
    },
    LAND_USE_MER_LIST: state => {
      return state.landUseMerList
    },
    REGION_LIST: state => {
      return state.regionList
    }
  }
}



// WEBPACK FOOTER //
// ./src/storages/modules/appStore.js